import postcss from 'postcss';

export function findStyleDefinition(selector, styleIndex) {
  const results = styleIndex[selector] || [];

  if (results.length === 0) {
    return `No styles found for selector: ${selector}`;
  }

  return results.map(r =>
    `File: ${r.file} (line ${r.line}):\n${r.rule}`
  ).join('\n\n---\n\n');
}

export async function buildStyleIndex(fileList, dbRef) {
  const index = {};

  // Parse CSS files
  for (const file of fileList.filter(f => f.Key.endsWith('.css'))) {
    try {
      const content = await dbRef.current.get('files', file.Key);
      if (!content) continue;

      const ast = postcss.parse(content, { from: file.Key });

      ast.walkRules(rule => {
        rule.selectors.forEach(selector => {
          if (!index[selector]) {
            index[selector] = [];
          }

          index[selector].push({
            file: file.Key,
            line: rule.source.start.line,
            column: rule.source.start.column,
            source: 'external',
            rule: rule.toString()
          });
        });
      });
    } catch (err) {
      console.error(`Error parsing CSS file ${file.Key}:`, err);
    }
  }

  // Parse HTML files for <style> tags
  for (const file of fileList.filter(f => f.Key.endsWith('.html') || f.Key.endsWith('.htm'))) {
    try {
      const content = await dbRef.current.get('files', file.Key);
      if (!content) continue;

      const styleTagRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
      let match;

      while ((match = styleTagRegex.exec(content)) !== null) {
        const cssContent = match[1];

        if (cssContent.includes('tiinyeditableimage') || cssContent.includes('tiinyeditabletext')) {
          continue;
        }

        try {
          const ast = postcss.parse(cssContent, { from: file.Key });

          ast.walkRules(rule => {
            rule.selectors.forEach(selector => {
              if (!index[selector]) {
                index[selector] = [];
              }

              index[selector].push({
                file: file.Key,
                line: rule.source.start.line,
                source: 'style-tag',
                rule: rule.toString()
              });
            });
          });
        } catch (err) {
          console.error(`Error parsing <style> in ${file.Key}:`, err);
        }
      }
    } catch (err) {
      console.error(`Error processing HTML file ${file.Key}:`, err);
    }
  }

  return index;
}

export async function rebuildStyleIndexForFile(cssFile, content, styleIndex) {
  // Clear old entries for this file
  Object.keys(styleIndex).forEach(selector => {
    styleIndex[selector] = styleIndex[selector].filter(
      entry => entry.file !== cssFile
    );
    if (styleIndex[selector].length === 0) {
      delete styleIndex[selector];
    }
  });

  // Parse and add new entries
  try {
    const ast = postcss.parse(content, { from: cssFile });

    ast.walkRules(rule => {
      rule.selectors.forEach(selector => {
        if (!styleIndex[selector]) {
          styleIndex[selector] = [];
        }

        styleIndex[selector].push({
          file: cssFile,
          line: rule.source.start.line,
          column: rule.source.start.column,
          source: 'external',
          rule: rule.toString()
        });
      });
    });
  } catch (err) {
    console.error(`Error rebuilding index for ${cssFile}:`, err);
  }

  return styleIndex;
}
